module.exports = __webpack_public_path__ + "static/img/lan_logo.cc86613a.png";